import type { ColumnType } from '@/types/domains/index';

/**
 * トップに並べるコラム系セクション。支給デザインの `sec_home-column` に対応する。
 *
 * 専用ページは作らず、外部の Note へ遷移させる（決定#29）。
 * カードの中身は **note の RSS フィード**（`/api/note-column?feed=<id>`）から取り、
 * 引けなかったときはカードを出さない（ハードコードした記事は持たない）。
 *
 * フィードを増やすときは `COLUMN_FEEDS` に1件足すだけでよい。トップに並ぶセクションも
 * サーバー側が取りにいく先も、この配列だけを見ている
 * （`id` はサーバー側で取得先を引くキー。任意のURLは受け付けないので、ここに無い feed は取得できない）。
 */

/**
 * 1セクションに並べるカードの枚数。
 *
 * **2件。** 支給デザイン（Figma）が横並び2件の形なので、それに合わせる
 * （2026-08-12 の事業側回答。当初案の「4件＝PC 2×2 / SP 1×4」は採らない）。
 * PC は1行2件なので2件でちょうど1行に収まる。増やすときは偶数にすると最終行が欠けない。
 */
export const COLUMN_ARTICLE_LIMIT: number = 2;

/**
 * お役立ちコラムの遷移先。**note のアカウントトップ**（2026-08-18 の事業側回答で確定）。
 *
 * **このリポジトリで唯一の定義。** ヘッダーのグローバルナビ・フッター・ハンバーガーは
 * `ChromeConst` がこれを import して使う。以前は `ChromeConst` が別に `'#'` を持っており、
 * **全ページのナビとフッターが押しても何も起きないリンクになっていた**。
 *
 * トップのセクションは RSS の `channel > link` が取れればそちらを使い、
 * 取れないとき（＝取得前・note 障害中）にこの値へ落ちる。
 * 2026-08-12 時点の回答は「該当マガジンページ」だったが、アカウント単位のフィードに
 * 変わったのに伴い 2026-08-18 にアカウントトップへ変更された。
 */
export const COLUMN_URL: string = 'https://note.com/orientalbio';

/**
 * フィード一覧。
 *
 * **今回のリニューアルは「お役立ちコラム」1本だけ**（2026-08-12 の事業側回答）。
 * 「研究・エビデンス」はセクションを分けずに出さない。note 側のマガジン分けは運用で用意される
 * 想定なので、出すことになったらここに1件足せば復活する（画面側は `COLUMN_FEEDS` の数だけ並ぶ）。
 *
 * **`rssUrl` は自社アカウントのフィード**（2026-08-18 の事業側回答で確定）。
 * **マガジン単位ではなくアカウント単位**なので、`channel > link` は
 * `https://note.com/orientalbio`（アカウントのトップ）になる。「すべて見る」はそこへ飛ぶ。
 * マガジンで分けることになったら `https://note.com/orientalbio/m/<マガジンID>/rss` に替える。
 */
export const COLUMN_FEEDS: ReadonlyArray<ColumnType.FeedSource> = [
  {
    id: 'column',
    title: 'お役立ちコラム',
    subtitle: '毎日をもっと心地よく。美容健康コラム',
    buttonLabel: 'すべてのお役立ちコラムを見る',
    rssUrl: 'https://note.com/orientalbio/rss',
  },
] as const;
